import request from '@/utils/request';
export function pushScenarioResource(data) {
  return request.post('admin/scene/push-scenario/resource', data);
}
export function messageConfigList(data) {
  return request.post('admin/message-config/list', data);
}
export function messageConfigChangeStatus(data) {
  return request.post('admin/message-config/status', data);
}
export function structureResource(data) {
  return request.post('admin/structure/list', data);
}
export function auditFlowResource(data) {
  return request.post('admin/audit-flow/auditFlowResource', data);
}
export function accountResource(data) {
  return request.post('admin/message-config/account-resource', data);
}
export function productNameResource(data) {
  return request.post('admin/v2/customer-insurance/resource', data);
}
export function reviewerCcResource(data) {
  return request.post('admin/flow-node/reviewerCcResource', data);
}

//获取场景配置列表
export function sceneConfigList(data) {
  return request.post('admin/scene/config/list', data);
}
export function messageConfigStore(data) {
  return request.post('admin/message-config/store', data);
}

//获取场景配置详情接口
export function messageConfigDetail(data) {
  return request.post('admin/message-config/detail', data);
}
//编辑场景配置接口
export function messageConfigEdit(data) {
  return request.post('admin/message-config/edit', data);
}